/* global Metro */
(function(Metro, $) {
    $.extend(Metro.locales, {
        'uk-UA': {
            "calendar": {
                "months": [
                    "Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень", "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень",
                    "Січ", "Лют", "Бер", "Кві", "Тра", "Чер", "Лип", "Сер", "Вер", "Жов", "Лис", "Гру"
                ],
                "days": [
                    "Неділя", "Понеділок", "Вівторок", "Середа", "Четвер", "П’ятниця", "Субота",
                    "Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб",
                    "Нед", "Пон", "Вiв", "Сер", "Чет", "Пят", "Суб"
                ],
                "time": {
                    "days": "ДНІ",
                    "hours": "ГОД",
                    "minutes": "ХВИЛ",
                    "seconds": "СЕК",
                    "month": "МІС",
                    "day": "ДЕНЬ",
                    "year": "РІК"
                },
                "weekStart": 1
            },
            "buttons": {
                "ok": "ОК",
                "cancel": "Відміна",
                "done": "Готово",
                "today": "Сьогодні",
                "now": "Зараз",
                "clear": "Очистити",
                "help": "Допомога",
                "yes": "Так",
                "no": "Ні",
                "random": "Випадково",
                "save": "Зберегти",
                "reset": "Скинути"
            },
            "table": {
                "rowsCount": "Показати записів:",
                "search": "Пошук:",
                "info": "Показано $1 з $2 по $3 записів",
                "prev": "Попередні",
                "next": "Наступні",
                "all": "Усі",
                "inspector": "Інспектор",
                "skip": "Перейти до сторінки",
                "empty": "Нема записів"
            },
            "colorSelector": {
                addUserColorButton: "ДОДАТИ В ЗРАЗКИ",
                userColorsTitle: "КОЛІРИ КОРИСТУВАЧА"
            },
            "switch": {
                on: "увм",
                off: "вім"
            }
        }
    });
}(Metro, m4q));